// @flow
import { document } from 'window';

import $ from 'jquery';
import Q from 'q';
import _ from 'lodash';

import modals from 'modals';

import onBeforeUnloadHandler from 'window-onbeforeunload-handler';

import server from 'server2';

import Model from './model.js';

import redirectToRgslifeModalTemplate from '../templates/redirect-to-rgslife-modal-template.html';
import redirectToRsaModalTemplate from '../templates/redirect-to-rsa-modal-template.html';

export default class ModalRedirectToOtherSiteController {
	constructor () {
		this._model = new Model();

		this._model
			.on('redirectClick', this._redirect)
			.on('closeModalClick', this._closeModal);

		this._redirectToRgslifeModal = modals.create({
			templateMode: 'content',
			template: {
				html: redirectToRgslifeModalTemplate(),
				data: this._model,
			},
		});

		this._redirectToRsaModal = modals.create({
			templateMode: 'content',
			template: {
				html: redirectToRsaModalTemplate(),
				data: this._model,
			},
		});

		$(document)
			.on('click', '[data-redirect-to-rgslife-site]', e => {
				e && e.preventDefault();
				this._fillRedirectInfo($(e.currentTarget));
				modals.show(this._redirectToRgslifeModal);
			})
			.on('click', '[data-redirect-to-rsa-site]', e => {
				e && e.preventDefault();
				this._fillRedirectInfo($(e.currentTarget));
				modals.show(this._redirectToRsaModal);
			});
	}

	_fillRedirectInfo (target) {
		this._model.redirectUrl(target.attr('data-redirect-url'));
		this._model.crossingEvent(target.attr('data-redirect-crossing-event'));
		this._model.openInNewWindow(target.attr('data-redirect-open-blank'));
	}

	_cleanRedirectInfo () {
		this._model.redirectUrl(null);
		this._model.crossingEvent(null);
		this._model.openInNewWindow(null);
	}

	_redirect = async () => {
		const crossingEvent = this._model.crossingEvent();
		const redirectUrl = this._model.redirectUrl();

		if (crossingEvent) {
			await server.my.api
				.post(['crossingEvents'], {
					body: {
						Event: crossingEvent,
					},
				})
				.catch(e => {
					console.warn('Error occurred while logging crossing event', e);
				});
		}

		if (this._model.openInNewWindow()) {
			onBeforeUnloadHandler.redirectToNewWindowWithoutAlert(redirectUrl);
			this._cleanRedirectInfo();
			return _.noop();
		}

		onBeforeUnloadHandler.redirectWithoutAlert(redirectUrl);
		return Q.delay(30 * 1000);
	}

	_closeModal = () => {
		this._cleanRedirectInfo();
	}
}
